import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ContactForm, VicSchoolContact, VicSchoolRequestPayload } from '../models/contact.model'
import { AppConfigurationService } from './app-configuration.service'

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private http = inject(HttpClient)
  private appConfigurationService = inject(AppConfigurationService)
  private readonly baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()

  public submitContact(contactForm: ContactForm): Observable<any> {
    const postUrl = `${this.baseSiteUrl}/contactUs/create?fields=DEFAULT`
    return this.http.post(postUrl, contactForm).pipe(catchError(this.handleError))
  }

  public submitVicSchoolContactForm(contactForm: VicSchoolContact): Observable<any> {
    const postUrl = `${this.baseSiteUrl}/school/create?fields=DEFAULT`
    const { needHelpWith, moreInfo, ...rest } = contactForm
    const payload: VicSchoolRequestPayload = { ...rest, help: needHelpWith, information: moreInfo }
    return this.http.post(postUrl, payload).pipe(catchError(this.handleError))
  }

  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message)
    } else {
      console.error(`Backend returned code ${error.status}, ` + `error: ${error.error}`)
    }
    return throwError(() => 'Error happened. please try again later.')
  }
}
